
export default {
	methods: {
		/**
     * Calculate the renewal date based on period date and renewal duration
     * @param {string} periodDate - Period date in MM/YYYY format
     * @param {number} renewDuration - Renewal duration (0: lifetime, 1: monthly, 12: yearly)
     * @returns {string|null} - Renewal date in MM/YYYY format or null for lifetime
     */
    /**
 * Calculates the renewal date based on period date and renewal duration
 * @param {string} periodDate - Period date in various formats:
 *    - ISO format (e.g., 2024-09-11T00:00:00.000Z)
 *    - MM/YYYY format (e.g., 09/2024)
 *    - YYYY-MM-DD format (e.g., 2024-09-11)
 * @param {number} renewDuration - Duration code (0 = A vie, 1 = Mensuel, 12 = Annuel)
 * @returns {string|null} - Renewal date in the same format as input or null if renewal is 'A vie'
 */
calculateRenewDate(periodDate, renewDuration) {
  if (!periodDate) return null;
  
  try {
    let date;
    
    // Parse different input formats
    if (periodDate.includes('T')) {
      date = new Date(periodDate);
    } else if (periodDate.includes('/')) {
      let [month, year] = periodDate.split('/');
      date = new Date(parseInt(year), parseInt(month) - 1, 1);
    } else if (periodDate.includes('-')) {
      date = new Date(periodDate);
    } else {
      return null;
    }
    
    if (isNaN(date.getTime())) return null;
    
    const renewDurationNum = parseInt(renewDuration, 10);
    
    switch (renewDurationNum) {
      case 0: return null; // "A vie"
      case 1: date.setMonth(date.getMonth() + 1); break; // "Mensuel"
      case 12: date.setFullYear(date.getFullYear() + 1); break; // "Annuel"
      default: date.setMonth(date.getMonth() + renewDurationNum); break;
    }
    
    // Format as YYYY-MM-DD HH:MM:SS
    return date.toISOString().replace('T', ' ').substring(0, 19);
    
  } catch (error) {
    console.error('Error calculating renewal date:', error);
    return null;
  }
},
  async getPeriodDateList(monthsToSubtract = 3) {
   try{
    const { default: moment } = await import('moment');

    // Load Moment.js and set the locale to French

      const periods = [];
      const currentMonth = moment(); // today
      const start = currentMonth.clone().subtract(monthsToSubtract, 'months');
      const end = currentMonth.clone().add(0, 'months');

      for (let m = start.clone(); m.isSameOrBefore(end, 'month'); m.add(1, 'month')) {
        periods.push({
          // name: m.format('MMMM YYYY').toString(), // e.g., "Mai 2025"
          name: m.format('MM/YYYY').toString(),   // e.g., "05/2025"
          date_value: m.format('MM/YYYY').toString()   // e.g., "05/2025"
        });
      }
      return periods.reverse(); // Reverse the order to have the most recent first

          }
          catch (error) {
            console.error('Error generating period date list:', error);
            return [];
          }
        },
        // Method 3: Simple boolean check if any URLs exist
  	getSocietyName(societies, societyId) {
			let society = societies.find((society) => society.id == societyId);
			return society.name || "";
		},
  	getMissionName(missions, id) {
			let missionObj = missions.find(
							(m) => m.id == Number(id)
						);
			return missionObj.perform || "";
		},
  getMatchingUrls(newNetlinks, existingNetlinks) {
    const matches = [];
    
    newNetlinks.forEach(newNetlink => {
        // Find matching existing netlink based on your duplicate criteria
        // (adjust this logic based on your duplicate detection rules)
        const match = existingNetlinks.find(existing => 
           existing.url_bought.trim() == newNetlink.url_bought.trim() &&
            existing.landing_page.trim() == newNetlink.landing_page.trim() &&
            existing.contract_id == newNetlink.contract_id &&
            existing.period_date == newNetlink.period_date
        );
        
        if (match) {
            matches.push({
                ...match,
                // Add any additional properties you want to show in the popup
                society_id: match.society_id,
                mission_id: match.mission_id,
                url_bought: match.url_bought,
                landing_page: match.landing_page,
                period_date: match.period_date
            });
        }
    });
    
    return matches;
},

markDuplicateNetlinks(allNetlinks, existingNetlinks) {
    console.log("Processing all netlinks for duplicates...");
    console.log("Total netlinks:", allNetlinks.length);
    console.log("Existing netlinks count:", existingNetlinks.length);
    
    // Return a new array with duplicate flags set
    return allNetlinks.map((netlink, index) => {
        // Only process new netlinks
        if (!netlink._isNew) {
            return netlink; // Return unchanged for existing netlinks
        }
        
        console.log("Processing new netlink at index", index, ":", netlink);
        
        // Debug: Test specific values
        console.log("Looking for match with:", {
            url_bought: netlink.url_bought ? netlink.url_bought.trim() : '',
            landing_page: netlink.landing_page ? netlink.landing_page.trim() : '',
            contract_id: netlink.contract_id,
            period_date: netlink.period_date
        });
        
        // Find if this new netlink matches an existing one
        const existingMatch = existingNetlinks.find(existing => {
            const urlMatch = existing.url_bought && netlink.url_bought && 
                existing.url_bought.trim() === netlink.url_bought.trim();
            const landingMatch = existing.landing_page && netlink.landing_page && 
                existing.landing_page.trim() === netlink.landing_page.trim();
            const contractMatch = existing.contract_id == netlink.contract_id;
            const periodMatch = existing.period_date == netlink.period_date;
            
            return urlMatch && landingMatch && contractMatch && periodMatch;
        });
        
        if (existingMatch) {
            console.log("✅ Found duplicate match:", existingMatch);
            // Return updated netlink with duplicate flags
            return {
                ...netlink,
                _isDuplicate: true,
                _existingId: existingMatch.id,
                _isNew: true // Keep this flag for processing
            };
        } else {
            console.log("❌ No duplicate found");
            // Return netlink marked as non-duplicate
            return {
                ...netlink,
                _isDuplicate: false
            };
        }
    });
}


}
};
